<script lang="ts">
  // UI
  import * as Popover from '$lib/components/ui/popover';
  import { Button } from '$lib/components/ui/button';
  import { Slider } from '$lib/components/ui/slider';
  import { Label } from '$lib/components/ui/label/index.js';

  // RoastLog
  import type { RoastingEvent } from '$lib/types/RoastLog';

  type SliderValue = number[] | undefined;

  interface Props {
    event: RoastingEvent;
    disabled?: boolean;
    eventTriggered: (params: { event: RoastingEvent; value: SliderValue }) => void;
  }

  let { event, disabled = true, eventTriggered }: Props = $props();

  // Internal state
  let value: SliderValue = $state();
  let displayVal: string = $derived.by(() => {
    if (value) {
      return value[0].toFixed(1);
    } else {
      return '0';
    }
  });

  // Set the initial value
  // svelte-ignore state_referenced_locally
  if (!value && event.scale?.max && event.scale?.step) {
    const { min, max, step } = {
      min: parseFloat(event.scale.min || '0'),
      max: parseFloat(event.scale.max),
      step: parseFloat(event.scale.step)
    };

    if (max !== null && step !== null) {
      const totalSteps = Math.round((max - (min || 0)) / step);
      value = [Math.round(min + (step * totalSteps) / 2)];
    }
  }

  const onSliderChange = (e: number[]) => {
    value = e;
  };
</script>

{#if event.scale?.max && event.scale?.step}
  <Popover.Root>
    <Popover.Trigger {disabled}>
      {#snippet child({ props })}
        <Button variant="default" {...props}>
          {event.name} to...
        </Button>
      {/snippet}
    </Popover.Trigger>
    <Popover.Content class="w-80 ">
      <div class="flex flex-col gap-4">
        <div class="flex gap-x-4">
          <Slider
            min={parseFloat(event.scale.min || '0')}
            max={parseFloat(event.scale.max)}
            step={parseFloat(event.scale.step)}
            onValueChange={onSliderChange}
            bind:value
          />
          <Label class="text-xl">{displayVal}</Label>
        </div>
        <div class="flex justify-end gap-x-2">
          <Popover.Close>
            <Button {disabled} variant="secondary">Cancel</Button>
          </Popover.Close>
          <Popover.Close>
            <Button {disabled} onclick={() => eventTriggered({ event, value })}>Save</Button>
          </Popover.Close>
        </div>
      </div>
    </Popover.Content>
  </Popover.Root>
{:else}
  <Button {disabled} onclick={() => eventTriggered({ event, value })}>{event.name}</Button>
{/if}
